// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { PostAgentGroupsDepsBody, BaseResponseListAgent1 } from '../../types';

/**
 * getAgentByGroupAndDepIds
 *
 * @export
 * @tags agent-group-controller
 * @link [POST] /agentGroups/deps
 */
export function postAgentGroupsDeps(data: PostAgentGroupsDepsBody): Promise<BaseResponseListAgent1>;
export function postAgentGroupsDeps(
    data: PostAgentGroupsDepsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseListAgent1>;
export function postAgentGroupsDeps(
    data: PostAgentGroupsDepsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseListAgent1> {
    return request<PostAgentGroupsDepsBody, never, never>('/agentGroups/deps', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postAgentGroupsDeps',
    });
}

export const meta = [
    { tags: ['agent-group-controller'], path: '/agentGroups/deps', method: 'post' },
];
